import React from 'react'

const Testimonial = ({name, text, img}) => {
  return (
    <aside className="testimonial-aside">
        <div className="testimonial-details">
          <div className="testimonial-img-container">
            <img src={"https://firebasestorage.googleapis.com/v0/b/fir-login-33c28.appspot.com/o/file%2Freal2.jpg?alt=media&token=41fa3f4a-4a04-4ed2-a7df-9ad21632ec40"} alt="testimonial" />
          </div>
          <p className="testimonial-statement">"{text}"</p>
          <small className="testimonial-name">{name}</small>
        </div>
    </aside>
  )
}

export default Testimonial
